import { render, staticRenderFns } from "./AlarmQueueFooter.vue?vue&type=template&id=6920baa6&scoped=true"
import script from "./AlarmQueueFooter.vue?vue&type=script&lang=ts"
export * from "./AlarmQueueFooter.vue?vue&type=script&lang=ts"
import style0 from "./AlarmQueueFooter.vue?vue&type=style&index=0&id=6920baa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920baa6",
  null
  
)

export default component.exports